import { gql } from 'apollo-boost';

// input UserPurchasesInput {
// 	 userId: ID!
// }

export const GET_USER_PURCHASES = gql`
  query ($data: UserPurchasesInput!) {
    getUserPurchases (data: $data) {
      purchases {
        id
        user {
          id
          planType
        }
        provider
        stripeId
        finalPrice
        currency
        plan {
          name
          stripePriceId
          type
          price
          stripeProductId
          currency
        }
        quantity
        type
        subscriptionStatus
        currentPeriodStart
        currentPeriodEnd
        subscriptionCancelledAt
        purchaseDate
        # RevenueCat specific fields
        entitlement_ids
        product_id
        transaction_id
        store
        revenueCatTransactionId
        app_id
        app_user_id
        country_code
        environment
        expiration_at_ms
        purchased_at_ms
        presented_offering_id
      }
    }
  }
`;
